<template>
    <div class="noBookBox">
        <p>您还没有{{ name }}过任何书籍，赶快去{{ name }}吧!</p>
    </div>
</template>
<script>
export default {
    data() {
        return {
            name: "收听"
        }
    },
    computed: {
        type() {
            return this.$route.query.type;
        }
    },
    mounted() {
        let that = this;
        if( that.type == "history" ) {
            that.name = "收听";
        }else if( that.type == "collect" ) {
            that.name = "收藏";
        }
    }
}
</script>
<style lang="scss" scoped>
    .noBookBox{
        padding: 200px 0;
        >p{
            @include secondary_color(#999);
            font-size: 24px;
            text-align: center;
        }
    }
</style>
